<template>
  <section class="fts-settings-card fts-settings-plan-review" aria-live="polite">
    <div>
      <h2>Review your change</h2>
      <p class="fts-settings-card-sub">
        Moving to {{ planName }}, billed {{ preview.interval === 'year' ? 'yearly' : 'monthly' }}{{ seatClause }}.
        Nothing is charged until you confirm.
      </p>
    </div>

    <div class="fts-settings-estimate-total">
      <div class="fts-settings-estimate-line" v-for="(line, i) in lines" :key="i">
        <span>
          <strong>{{ line.description || 'Adjustment' }}</strong>
          <small v-if="line.quantity > 1">Qty {{ line.quantity }}</small>
        </span>
        <span class="fts-settings-plan-review-amount">{{ money(line.amount) }}</span>
      </div>
      <div class="fts-settings-estimate-rule"></div>
      <div class="fts-settings-estimate-line is-total">
        <span>
          <strong>Due now</strong>
          <small>Before tax, prorated for the days left in this period</small>
        </span>
        <span class="fts-settings-plan-review-amount">{{ money(preview.amountDue) }}</span>
      </div>

      <button type="button" class="fts-settings-btn is-primary" :disabled="busy" @click="$emit('confirm')">
        Confirm change
      </button>
      <button type="button" class="fts-settings-btn" :disabled="busy" @click="$emit('cancel')">
        Cancel
      </button>
      <span class="fts-settings-note">
        Pro seats follow the plan: seats beyond the one included are billed as they are assigned.
      </span>
    </div>
  </section>
</template>

<script>
/**
 * Settings › Plan — the in-app review of a plan change (SS06197).
 *
 * Stripe's billing portal cannot change a subscription with more than one item, so once Pro seats
 * are billed as their own line the change is previewed here (api/billing/plan-change/preview,
 * Stripe's own invoice preview) and confirmed here (api/billing/plan-change). Amounts are Stripe's,
 * in minor units.
 */
export default {
  name: "SettingsPlanReview",
  props: {
    preview: { type: Object, required: true },
    busy: Boolean,
  },
  computed: {
    lines() {
      return (this.preview && this.preview.lines) || [];
    },
    planName() {
      const k = String((this.preview && this.preview.planKey) || "");
      return k.charAt(0).toUpperCase() + k.slice(1);
    },
    seatClause() {
      const seats = Number(this.preview && this.preview.seats) || 0;
      return seats > 0 ? `, with ${seats} add-on seat${seats === 1 ? "" : "s"}` : "";
    },
  },
  methods: {
    money(minor) {
      const symbols = { usd: "US$", sgd: "S$", myr: "RM" };
      const currency = String((this.preview && this.preview.currency) || "usd").toLowerCase();
      const symbol = symbols[currency] || `${currency.toUpperCase()} `;
      const n = Number(minor) / 100;
      if (!isFinite(n)) return "";
      // A real minus sign: a hyphen lets the line break between the sign and the amount.
      const sign = n < 0 ? "−" : "";
      return sign + symbol + Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style lang="scss">
/* The estimate's receipt panel is a fixed side column; here it is the card's whole content. */
.fts-settings-plan-review {
  .fts-settings-estimate-total {
    width: 100%;
    max-width: 560px;
  }

  .fts-settings-plan-review-amount {
    white-space: nowrap;
  }
}
</style>
